import React, { Component } from 'react'
import { createStyles, WithStyles, withStyles, Paper, Divider, Typography, FormControl, Select, MenuItem, Fab, Grid, CircularProgress } from '@material-ui/core'
import { connect } from 'react-redux'
import FormDialog from '../../Components/FormDialog';
import { ReduxStore } from '../../stores';
import Theme from '../../Resources/Theme';
import { Book } from './@types';
import { Picture } from '../Pictures/@types';
import MuiTheme from '../../MuiTheme';
import FileInput from '../../Components/Input/FileInput';
import pictureUtils from '../../Resources/PictureUtils';
import { OBook } from './Model';
import { TextValidator } from 'react-material-ui-form-validator'
import KeywordsForm from '../../Components/KeywordsForm';
import { TDispatch } from '../../Resources/GarbageUtils';
import { AxiosPromise } from 'axios';
import { Editor } from '@tinymce/tinymce-react';
import { TINY_API_KEY } from 'Resources/Config';

interface IDispatchProps {
    addBook: (data: Partial<Book>) => AxiosPromise
}

interface IStateProps {

}

interface OwnProps {
    open: boolean
    book?: Book
    onClose?: () => void
}

interface IProps extends WithStyles<typeof STYLES>, IDispatchProps, OwnProps {

}

interface IState {
    keywordField?: string
    showForm: boolean
    uploadingPicture: boolean
    submittingForm: boolean
    formData: Partial<Book>
}

class Form extends Component<IProps, IState> {

    constructor(props: IProps) {
        super(props);
        this.state = {
            showForm: props.open,
            keywordField: '',
            uploadingPicture: false,
            submittingForm: false,
            formData: {
                name: '',
                author: '',
                edition: 0,
                keywords: [],
                description: '',
                shortDescription: '',
                affiliates: [{
                    site: 'amazon',
                    link: '',
                    name: ''
                }]
            }
        }
    }

    componentDidMount() {
        const { book = undefined } = this.props;
        if (this.props.book) {
            this.setState({ formData: { ...this.state.formData, ...book } });
        }
    }

    handleChange = (e: React.ChangeEvent<HTMLInputElement>) => this.setState({ formData: { ...this.state.formData, [e.target['name']]: e.target['value'] } });

    deleteAffiliateItem = (index: number) => {
        let affiliates = [...(this.state.formData.affiliates || [])];
        affiliates.splice(index, 1);
        this.setState({
            formData: { ...this.state.formData, affiliates }
        })
    }

    addAffiliateItem = () => {
        let affiliates = [...(this.state.formData.affiliates || [])];
        affiliates.push({ site: 'amazon', link: '', name: '' });
        this.setState({ formData: { ...this.state.formData, affiliates } })
    }

    handleAffiliateChange = (name: string, value: string, index: number) => {
        let affiliates = [...(this.state.formData.affiliates || [])];
        affiliates[index].name = value;
        this.setState({ formData: { ...this.state.formData, affiliates } })
    }

    handlePictureSelect = async (files: Array<any>) => {
        this.setState({ uploadingPicture: true });
        const res = await pictureUtils.upload(files[0], 'books');
        let pictures = [...(this.state.formData._pictures || [])];
        pictures.push(res.data as Picture);
        this.setState({ formData: { ...this.state.formData, _pictures: pictures }, uploadingPicture: false });
    }

    handleSubmit = async () => {
        this.setState({ submittingForm: true });
        await this.props.addBook!(this.state.formData).catch(error => this.setState({ submittingForm: false })).catch(error => {
            console.log('Error adding book', error.response.data);
            throw error.response.data;
        });
        await this.setState({ submittingForm: false });
        this.handleClose();
    }

    handleClose = () => {
        this.setState({ showForm: false });
        typeof this.props.onClose === 'function' && this.props.onClose();
    }

    render() {
        const { classes } = this.props
        const { formData, submittingForm = false } = this.state
        return (
            <div>
                <FormDialog
                    open={this.state.showForm}
                    onCloseButtonClick={this.handleClose}
                    title={'Add New Book'}
                    onSubmit={this.handleSubmit}
                    loading={submittingForm}
                    dialog={false}
                >
                    <Paper className={classes.formPaper} >
                        <Grid container spacing={2} >
                            <Grid item sm={4} >
                                <div className={classes.coverContainer} >
                                    {this.state.uploadingPicture ? <CircularProgress thickness={5} /> : null}
                                    <Fab size='small' color='primary' > <FileInput onDone={this.handlePictureSelect} withCropping cropConfig={{ aspect: 0.7 }} /> <i className={'material-icons'}>add</i> </Fab>
                                    {formData._pictures && formData._pictures.length > 0 ? <img src={((formData._pictures[0] || {}).url || '')} alt='book cover' /> : null}
                                </div>
                            </Grid>
                            <Grid item sm={8} >
                                <TextValidator
                                    placeholder='Book Name'
                                    fullWidth
                                    name='name'
                                    value={formData.name || ''}
                                    onChange={this.handleChange}
                                    autoComplete={'off'}
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                />
                                <TextValidator
                                    placeholder='Author Name'
                                    fullWidth
                                    name='author'
                                    value={formData.author || ''}
                                    onChange={this.handleChange}
                                    autoComplete={'off'}
                                    validators={['required']}
                                    errorMessages={['This field is required']}
                                    className={classes.inputField}
                                />
                                <TextValidator
                                    type='number'
                                    placeholder='Edition'
                                    fullWidth
                                    name='edition'
                                    value={formData.edition}
                                    onChange={this.handleChange}
                                    autoComplete={'off'}
                                    className={classes.inputFieldHeight}
                                    validators={['required', 'isPositive']}
                                    errorMessages={['This field is required', 'Only positive numbers are allowed']}
                                />
                            </Grid>
                        </Grid>
                        <TextValidator
                            placeholder='Short Description'
                            fullWidth
                            name='shortDescription'
                            value={formData.shortDescription || ''}
                            onChange={this.handleChange}
                            autoComplete={'off'}
                            multiline
                            errorMessages={['This field is required']}
                            className={classes.inputField}
                        />
                        <Editor
                            apiKey={TINY_API_KEY}
                            init={{
                                minHeight: '200px !important',
                                toolbar: 'bold link italic code undo redo',
                                plugins: ['link'],
                                min_height: 200,
                            }}
                            initialValue={formData.description || ''}
                            onChange={e => { this.setState({ formData: { ...formData, description: e.target.getContent() } }) }}
                        />
                        <KeywordsForm initialKeywords={this.props.book?.keywords} onKeywordsUpdate={keywords => this.setState({ formData: { ...this.state.formData, keywords } })} />
                        <Divider color={Theme.Colors.Grey1} />
                        <div>
                            <Typography variant='h5' color='textPrimary' >Affiliate Links</Typography>
                            <div>
                                {
                                    formData.affiliates &&
                                    (formData.affiliates).map((item, index) => {
                                        return (
                                            <Paper key={index} className={classes.affiliatePaper} >
                                                <Grid container spacing={4} >
                                                    <Grid item lg={6} >
                                                        <FormControl fullWidth className={classes.selectInput} >
                                                            <Select
                                                                className={classes.selectInput}
                                                                value={item.site}
                                                                onChange={e => this.handleAffiliateChange(e.target.name as string, e.target.value as string, index)}
                                                                inputProps={{
                                                                    name: 'site'
                                                                }}
                                                            >
                                                                <MenuItem value='amazon'>AmazonIn</MenuItem>
                                                                <MenuItem value='flipkart'>Flipkart</MenuItem>
                                                            </Select>
                                                        </FormControl></Grid>
                                                    <Grid item lg={6} >
                                                        <TextValidator
                                                            placeholder='Name'
                                                            fullWidth
                                                            value={item.name}
                                                            name='name'
                                                            onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleAffiliateChange(e.target['name'], e.target['value'], index)}
                                                            validators={['required']}
                                                            errorMessages={['This field is required']}
                                                        />
                                                    </Grid>
                                                </Grid>
                                                <TextValidator
                                                    placeholder='Link'
                                                    fullWidth
                                                    value={item.link}
                                                    name='link'
                                                    onChange={(e: React.ChangeEvent<HTMLInputElement>) => this.handleAffiliateChange(e.target['name'], e.target['value'], index)}
                                                    validators={['required']}
                                                    errorMessages={['This field is required']}
                                                    className={classes.inputField}
                                                />
                                                <Fab color='default' size='small' onClick={e => this.deleteAffiliateItem(index)} ><i className={'material-icons'} >close</i></Fab>
                                            </Paper>
                                        )
                                    })
                                }
                                <div className={classes.addAffiliateButtonContainer} >
                                    <Fab color='secondary' size='medium' onClick={this.addAffiliateItem} ><i className='material-icons'>add</i> </Fab>
                                </div>
                            </div>
                        </div>
                    </Paper>
                </FormDialog>
            </div>
        )
    }
}

const mapStateToProps = (state: ReduxStore): IStateProps => ({

})

const mapDispatchToProps = (dispatch: TDispatch): IDispatchProps => ({
    addBook: (data) => dispatch(data.id ? OBook.putItem(data) : OBook.postItem(data))
})

const STYLES = (theme: typeof MuiTheme) => createStyles({
    formPaper: {
        boxSizing: 'border-box',
        width: 650,
        padding: 50,
        '& > div': {
            marginBottom: 20,
        },
    },
    inputFieldHeight: {
        height: 48,
        marginTop: 25
    },
    affiliatePaper: {
        position: 'relative',
        padding: 12,
        marginTop: 25,
        '& > button': {
            position: 'absolute',
            top: '-18px', right: '-18px'
        }
    },
    selectInput: {
        height: '100%'
    },
    addAffiliateButtonContainer: {
        display: 'flex',
        justifyContent: 'center',
        marginTop: 20
    },
    coverContainer: {
        width: '100%', height: '100%', minHeight: 150,
        backgroundColor: Theme.Colors.Secondary.main,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        position: 'relative',
        '& > button': {
            position: 'absolute',
            bottom: '16px', right: '16px'
        },
        '& > img': {
            width: '100%'
        }
    },
    inputField: {
        marginTop: 25
    }
})

export default connect<IStateProps, IDispatchProps, OwnProps, ReduxStore>(mapStateToProps, mapDispatchToProps)(withStyles(STYLES)(Form))